import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-stone-950 text-stone-400">
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">

                    {/* Brand */}
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <img
                                src="/images/Logo.png"
                                alt="Kia Kaha"
                                className="h-10 w-auto opacity-70"
                            />
                            <span className="font-serif text-xl font-light text-white tracking-wider">
                                Kia Kaha
                            </span>
                        </div>
                        <p className="font-sans text-sm leading-relaxed text-stone-500 max-w-xs">
                            Custom home construction in the Sea to Sky corridor.
                            From foundations to finishing since 2003.
                        </p>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="font-sans text-xs tracking-widest uppercase text-stone-500 mb-5">
                            Navigate
                        </h4>
                        <nav className="flex flex-col gap-3">
                            {[
                                { text: 'Home', path: '/' },
                                { text: 'Our Services', path: '/services' },
                                { text: 'Projects Gallery', path: '/gallery' },
                                { text: 'About Us', path: '/about' },
                                { text: 'Contact', path: '/contact' },
                            ].map(({ text, path }) => (
                                <Link
                                    key={path}
                                    to={path}
                                    className="font-sans text-sm text-stone-400 hover:text-jade-400 transition-colors duration-200"
                                >
                                    {text}
                                </Link>
                            ))}
                        </nav>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-sans text-xs tracking-widest uppercase text-stone-500 mb-5">
                            Get In Touch
                        </h4>
                        <a
                            href="mailto:kiakahaconstruction@gmail.com"
                            className="font-sans text-sm text-stone-400 hover:text-jade-400 transition-colors duration-200 block mb-2"
                        >
                            kiakahaconstruction@gmail.com
                        </a>
                        <p className="font-sans text-sm text-stone-500">
                            Squamish, BC
                        </p>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="font-sans text-xs text-stone-600 tracking-wide">
                        © {new Date().getFullYear()} Kia Kaha Construction. All rights reserved.
                    </p>
                    <p className="font-sans text-xs text-stone-700 tracking-widest uppercase">
                        Sea to Sky Corridor · Est. 2003
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
